import { render } from "./SiteReports.vue?vue&type=template&id=9f72cd12"
import script from "./SiteReports.vue?vue&type=script&lang=js"
export * from "./SiteReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__